export default __webpack_public_path__ + "assets/590ae48cb5bbc4bdbed61ddd0d47f9b6.png";